import { Controller } from "@hotwired/stimulus";
import { TurnstileWidgetLifecycle } from "../components/turnstile-widget-lifecycle";

export default class extends Controller {
  static targets = ["widget"];
  static values = {
    siteKey: String,
    theme: { type: String, default: "light" },
  };

  connect() {
    this.lifecycle = new TurnstileWidgetLifecycle({
      container: this.widgetTarget,
      script: document.querySelector("script[data-turnstile-api]"),
      siteKey: this.siteKeyValue,
      theme: this.themeValue,
      apiProvider: () => window.turnstile,
    });
    this.lifecycle.connect();
  }

  disconnect() {
    this.lifecycle?.disconnect();
    this.lifecycle = null;
  }
}
